export const SET_TOGGLE_SIDEBAR     = 'GENERAL/SET_TOGGLE_SIDEBAR'
export const SIGN_OUT               = 'GENERAL/SIGN_OUT'
export const SAVE_RESULT_NRW_CALCULATE = 'GENERAL/SAVE_RESULT_NRW_CALCULATE'
export const STORE_DATA_NRW_BY_DMA = 'GENERAL/STORE_DATA_NRW_BY_DMA'
export const STORE_LIST_DMA_FOR_SELECT = 'GENERAL/STORE_LIST_DMA_FOR_SELECT'
export const STORE_SEARCH_MONTH = 'GENERAL/STORE_SEARCH_MONTH'
export const STORE_SEARCH_YEAR = 'GENERAL/STORE_SEARCH_YEAR'
export const STORE_SEARCH_DMA = 'GENERAL/STORE_SEARCH_DMA'